import React from "react";
import {Box, Typography} from "@mui/material";
import styles from "./Search.module.css"
import {CustomInput, Loader, MovieCard} from "../../components";
import {useSearchParams} from "react-router-dom";
import {EmptyLogo} from "../../assets/files";
import {useTranslation} from "react-i18next";
import {useGetSearchPageQuery} from "../../api/modules";
import {useUserRole} from "../../hooks/useUserRole";

const Search = () => {
    const {t} = useTranslation("translations");
    const [searchParams, setSearchParams] = useSearchParams();
    const query = searchParams.get("query") || "";
    const page = searchParams.get("page") || "1";
    const role = useUserRole();
    const shouldSkip = query.length < 2;
    const {data, isFetching} = useGetSearchPageQuery(
        {query, page, role},
        {skip: shouldSkip}
    );
    const showEmptyState = !isFetching && (shouldSkip || (data && data.length === 0));

    return (
        <Box className={styles.root}>
            <div className={styles.content}>
                <Typography variant="h4" className={styles.title}>{t("Aside.search")}</Typography>
            </div>
            <div className={styles.search}>
                <CustomInput
                    startIcon
                    name="search"
                    placeholder={t("Aside.search")}
                    value={query}
                    onChange={(e) => setSearchParams({page: "1", query: e.target.value})}
                />
            </div>
            {isFetching && <Loader className={styles.loader}/>}
            {!isFetching && !shouldSkip && data && data.length > 0 && (
                <Box className={styles.content_inner}>
                    {data.map((e, i) => (
                        <div className={styles.card} key={i}>
                            <MovieCard data={e}/>
                        </div>
                    ))}
                </Box>
            )}
            {showEmptyState && <div className={styles.loader}>
              <EmptyLogo/>
              <Typography variant={"subtitle2"} maxWidth={300}>{t("Details.notFindAnythingMatching")}</Typography>
            </div>}
        </Box>
    );
};

export default Search;
